var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDeleteButtonDefault(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M4.88888889,11.7619048 C4.88888889,12.3206349 5.35555556,12.7777778 5.92592593,12.7777778 L10.0740741,12.7777778 C10.6444444,12.7777778 11.1111111,12.3206349 11.1111111,11.7619048 L11.1111111,6.68253968 C11.1111111,6.12380952 10.6444444,5.66666667 10.0740741,5.66666667 L5.92592593,5.66666667 C5.35555556,5.66666667 4.88888889,6.12380952 4.88888889,6.68253968 L4.88888889,11.7619048 Z M11.4285714,3.59259259 L10,3.59259259 L9.59428571,3.17185185 C9.49142857,3.06518519 9.34285714,3 9.19428571,3 L6.80571429,3 C6.65714286,3 6.50857143,3.06518519 6.40571429,3.17185185 L6,3.59259259 L4.57142857,3.59259259 C4.25714286,3.59259259 4,3.85925926 4,4.18518519 C4,4.51111111 4.25714286,4.77777778 4.57142857,4.77777778 L11.4285714,4.77777778 C11.7428571,4.77777778 12,4.51111111 12,4.18518519 C12,3.85925926 11.7428571,3.59259259 11.4285714,3.59259259 Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#005082",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeleteButtonDefault);
export default __webpack_public_path__ + "static/media/icon_delete_button_default.a21fdba2c243aba47f0bda33d4da8b4f.svg";
export { ForwardRef as ReactComponent };